
const envConfig = {
    API_URL: process.env.REACT_APP_API_URL || 'https://hydrosecure-demo.iwmi.org/diwasa_api', // default URL if not set
    API_URL_P3: process.env.REACT_APP_API_URL_P3 || 'https://yndn6rvpa3.execute-api.us-west-1.amazonaws.com/diwasa_api', // default URL if not set
    GEOSRV_URL: process.env.REACT_APP_GEOSRV_URL || 'https://hydrosecure-demo.iwmi.org/geoserver',
    GEOSRV_USR: process.env.REACT_APP_API_USR,
    GEOSRV_PWD: process.env.REACT_APP_API_PWD,
};

export default envConfig;
